import { Component, OnInit } from '@angular/core';
import { ClientService } from '../services/client.service';
import { NgForm } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-create',
  templateUrl: './client-create.component.html',
  styleUrls: ['./client-create.component.css']
})
export class ClientCreateComponent implements OnInit {

  newClient: ClientEditDetails = {
    client_name: '',
    company_name: '',
    billing_frequency: 'weekly'
  } as ClientEditDetails;
  isSaving: boolean = false;
  errorMessage: string = "";
  successMessage: string = "";
  currentUser: User = null;

  constructor(
    private clientService: ClientService, 
    private authService: AuthService, 
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authService.getUserFromToken();
    if(this.currentUser){
      this.newClient.owner = this.currentUser.userid;
    }

  }

  saveClient(form: NgForm) {
    this.isSaving = true;
    this.errorMessage = "";
    this.successMessage = "";
    if (form.valid) {
      this.clientService.newClient(this.newClient).subscribe({
        next: (response: ClientDetailsResponse) => {
          this.successMessage = "Client created successfully!";
          setTimeout(() => {
            this.router.navigate(['/clients', response.data.client_id, 'details']);
          }, 500);
        },
        error: (error) => {
          this.errorMessage = `Failed to create client. ${error.error.message}`;
        },
        complete: () => {
          this.isSaving = false;
        }
      });
    }
  }

}
